/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetStock200ResponseAllOfData } from './GetStock200ResponseAllOfData';
import {
    GetStock200ResponseAllOfDataFromJSON,
    GetStock200ResponseAllOfDataFromJSONTyped,
    GetStock200ResponseAllOfDataToJSON,
} from './GetStock200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetStock200ResponseAllOf
 */
export interface GetStock200ResponseAllOf {
    /**
     * 
     * @type {GetStock200ResponseAllOfData}
     * @memberof GetStock200ResponseAllOf
     */
    data: GetStock200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetStock200ResponseAllOf interface.
 */
export function instanceOfGetStock200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetStock200ResponseAllOfFromJSON(json: any): GetStock200ResponseAllOf {
    return GetStock200ResponseAllOfFromJSONTyped(json, false);
}

export function GetStock200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStock200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetStock200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetStock200ResponseAllOfToJSON(value?: GetStock200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetStock200ResponseAllOfDataToJSON(value.data),
    };
}

